<sgt-multi-select
  [settings]="settings"
  [options]="options"
  [(ngModel)]="idsOperacoesContaOrdem"
  (ngModelChange)="onSelectionChange()"
  (search)="onSearch()">
</sgt-multi-select>
